<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-select style="width: 200px" v-model="channel" allowClear @change="init_table_data"
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option v-if="channelItem.status==1"
                           :key="channelItem.channel"
                           :value="channelItem.channel"
                           :label="channelItem.name"
                           v-for="channelItem in channelList">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
        <a-button style="margin-left: 5px;" type="danger" ghost @click="openChannel()">渠道管理</a-button>
      </a-form-item>
      <a-form-item>
        <a-select style="width: 200px" v-model="country" allowClear @change="init_table_data"
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择国家">
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{countryItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_table_data()" />
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" @click="addData()">新增数据</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.id" :loading="tableLoad"
             bordered :pagination="false">
      <template slot="spend" slot-scope="text,recode">
        <a-input v-if="recode.id==editId" v-model="recode.spend"></a-input>
        <div v-else>{{text}}</div>
      </template>
      <template slot="installs" slot-scope="text,recode">
        <a-input v-if="recode.id==editId" v-model="recode.installs"></a-input>
        <div v-else>{{text}}</div>
      </template>
      <template slot="action" slot-scope="text,recode">
        <a-button v-if="editId!=recode.id" type="danger" size="small" @click="deleteInfo(recode.id)">删除</a-button>
        <a-button v-else type="primary" size="small" @click="doEditInfo(recode)">保存</a-button>
        <a-button v-if="editId!=recode.id" type="info" size="small" @click="editInfo(recode.id)">编辑</a-button>
        <a-button v-else type="danger" ghost size="small" @click="()=>{editId=0}">取消</a-button>
      </template>
    </a-table>
    <ChannelPanel :show-panel="channelShow" :channel-list="channelList" @close-dialog="closeChanel"></ChannelPanel>
    <AddPanel :show-panel="addShow" :channel-list="channelList" @close-dialog="closeAdd"></AddPanel>
  </div>
</template>

<script>
import ChannelPanel from "./ChannelPanel";
import AddPanel from "./AddPanel";
import {DeleteSpendSelf, EditSpendSelf, GetSpendSelf, GetSpendSelfChannel} from "../../../api/v1/spend_self_api";
export default {
  name: "Index",
  components: {AddPanel, ChannelPanel},
  data(){
    return {
      channelList:[],
      country:[],
      channel:[],
      date:[],
      tableLoad:false,
      tableData:[],
      channelShow:false,
      addShow:false,
      editId:0,
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        { title: '日期', dataIndex: 'date',align:'center'},
        { title: '国家', dataIndex: 'country',align:'center'},
        { title: '花费', dataIndex: 'spend', scopedSlots: { customRender: 'spend' },align:'center'},
        { title: '新增', dataIndex: 'installs', scopedSlots: { customRender: 'installs' },align:'center'},
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' },width:'200px',align:'center'},
      ]
      return _table_columns
    },
    getAppId(){
      return this.$store.getters.getAppId
    },
  },
  watch:{
    getAppId:{
      handler(newName, oldName) {
        this.init_table_data()
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.init_table_data()
    this.init_channel_data()
  },
  methods:{
    init_channel_data(){
      GetSpendSelfChannel({}).then(resp => {
        if (resp.code===200){
          this.channelList = resp.data
        }
      })
    },
    init_table_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetSpendSelf({
        channel:this.channel,
        country:this.country,
        date:this.date,
        app_id:this.getAppId
      }).then(resp => {
        this.tableLoad = false
        if (resp.code==200){
          this.tableData = resp.data.list
          this.date = resp.data.date
        }
      })
    },
    editInfo(id){
      this.editId = id
    },
    doEditInfo(recode){
      EditSpendSelf({
        id:recode.id,
        spend:recode.spend,
        installs:recode.installs
      }).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.editId = 0
          this.init_table_data()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    deleteInfo(id){
      DeleteSpendSelf({id:id}).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.init_table_data()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    openChannel(){
      this.channelShow = true
    },
    closeChanel(isClose){
      if (isClose){
        this.channelShow = false
      }
      this.init_channel_data()
    },
    closeAdd(){
      this.addShow = false
      this.init_table_data()
    },
    addData(){
      this.addShow = true
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Self/Index.vue